module.exports = __webpack_public_path__ + "img/AD.e2df544d.png";